import pluralize from 'pluralize';
import moment from 'moment';

export default {
  crawlerStatusBar: {
    crawlerQueue: (jobsCount) => `Crawler queue: ${pluralize('job', jobsCount, true)}`,
    waitTime: (minutesCount) => `Wait time: ${moment.duration(minutesCount, 'minutes').humanize()}`,
  },
};
